import PageHero from "@/components/PageHero";
import { BRAND } from "@/data/content";

const SECTIONS = [
  {
    h: "1. Information We Collect",
    p: "When you submit our contact form or book a consultation, we collect the information you provide — such as your name, email address, phone number, area of interest, and any message content. We may also collect basic usage data through standard web analytics.",
  },
  {
    h: "2. How We Use Your Information",
    p: "We use your information solely to respond to your enquiry, schedule and deliver consultations, and communicate relevant service information. We do not sell your personal data to third parties.",
  },
  {
    h: "3. Booking & Third-Party Services",
    p: "Consultation scheduling is handled via Calendly and email delivery via our email provider. These services process the data necessary to complete your booking and notifications, subject to their own privacy policies.",
  },
  {
    h: "4. Data Retention",
    p: "We retain submitted enquiry data for as long as necessary to provide our services and to comply with legal obligations. You may request deletion of your data at any time.",
  },
  {
    h: "5. Your Rights",
    p: "Depending on your jurisdiction, you may have the right to access, correct, or delete your personal information, and to object to certain processing. Contact us to exercise these rights.",
  },
  {
    h: "6. Contact",
    p: "For any privacy-related questions or requests, please reach out through our contact page.",
  },
];

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <PageHero eyebrow="Legal" title="Privacy Policy" subtitle={`How ${BRAND} collects, uses, and protects your information.`} />
      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <p className="text-gl-text2/70 text-sm mb-10">
            This is a professional placeholder policy. Please review it with qualified legal counsel before relying on it.
          </p>
          <div className="space-y-10">
            {SECTIONS.map((s) => (
              <div key={s.h}>
                <h2 className="font-serif-display text-2xl text-gl-text mb-3">{s.h}</h2>
                <p className="text-gl-text2 font-light leading-relaxed">{s.p}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
